import {
  FilterItemBrandResource,
  FilterItemResource,
  FilterRecallItemType,
  FilterStatusItemType,
  MinMaxFilter,
} from './FilterTypes';

export type PortfolioFilterResource = {
  assignees: FilterItemResource[];
  maxBps: number;
  minBps: number;
  maxInMarketScore: number;
  minInMarketScore: number;
  maxVehicleScore: number;
  minVehicleScore: number;
  maxDealScore: number;
  minDealScore: number;
  dealTypes: FilterItemResource[];
  maxDate: Date;
  minDate: Date;
  maxAgeDate: Date;
  minAgeDate: Date;
  soldBy: FilterItemResource[];
  optOutPreference: FilterItemResource[];
  currentVehicleTrims: FilterItemResource[];
  currentVehicleModels: FilterItemResource[];
  currentVehicleYears: FilterItemResource[];
  currentVehicleMakes: FilterItemBrandResource[];
  replacementVehicleTrims: FilterItemResource[];
  replacementVehicleModels: FilterItemResource[];
  replacementVehicleYears: FilterItemResource[];
  replacementVehicleTypes: FilterItemResource[];
  replacementVehicleMakes: FilterItemBrandResource[];
  currentVehicleTypes: FilterItemResource[];
  replacementVehicleSelection: FilterItemResource[];
  colors: FilterItemResource[];
  incentives: FilterItemResource[];
  insights: FilterItemResource[];
  status: FilterStatusItemType[];
  recall: FilterRecallItemType[];
  campaignActivityViewCounts: FilterItemResource[];
  campaignExpiryDates: FilterItemResource[];
  fordIncentiveNames: FilterItemResource[];
  shopperActivity: FilterItemResource[];
};

export type PortfolioSelectedFilterResource = {
  assignees: FilterItemResource[];
  bpsValue: MinMaxFilter<number>;
  inMarketScore: MinMaxFilter<number>;
  vehicleScore: MinMaxFilter<number>;
  dealScore: MinMaxFilter<number>;
  dealTypes: FilterItemResource[];
  lastUpdated: MinMaxFilter<number>;
  soldBy: FilterItemResource[];
  optOutPreference: FilterItemResource[];
  currentVehicleTrims: FilterItemResource[];
  currentVehicleModels: FilterItemResource[];
  currentVehicleYears: FilterItemResource[];
  currentVehicleMakes: FilterItemBrandResource[];
  currentVehicleRate: MinMaxFilter<number>;
  replacementVehicleTrims: FilterItemResource[];
  replacementVehicleModels: FilterItemResource[];
  replacementVehicleYears: FilterItemResource[];
  replacementVehicleSelection: FilterItemResource;
  replacementVehicleTypes: FilterItemResource[];
  replacementVehicleMakes: FilterItemBrandResource[];
  replacementVehicleRate: MinMaxFilter<number>;
  currentVehicleTypes: FilterItemResource;
  colors: FilterItemResource[];
  incentives: FilterItemResource[];
  paymentsRemaining: MinMaxFilter<number>;
  isTrimConfirmationRequired: boolean;
  currentVehicleMileage: MinMaxFilter<number>;
  replacementVehicleMileage: MinMaxFilter<number>;
  monthsOfOwnership: MinMaxFilter<number>;
  insights: FilterItemResource[];
  ageDays: MinMaxFilter<number>;
  status: FilterStatusItemType;
  lastServiceDate: MinMaxFilter<number>;
  campaignActivityViewCounts: FilterItemResource[];
  recall: FilterRecallItemType[];
  campaignExpiryDates: FilterItemResource[];
  fordIncentiveNames: FilterItemResource[];
  shopperActivity: FilterItemResource;
};

export const initialBpsValue: MinMaxFilter<number> = { min: 0, max: 100 };
export const initialInMarketScoreValue: MinMaxFilter<number> = { min: 0, max: 100 };
export const initialVehicleScoreValue: MinMaxFilter<number> = { min: 0, max: 100 };
export const initialDealScoreValue: MinMaxFilter<number> = { min: 0, max: 100 };

export const initialLastUpdated: MinMaxFilter<number> = { min: 0, max: 9999 };

export const defaultRange: MinMaxFilter<number> = { min: null, max: null };

export const defaultStatus: FilterStatusItemType = {
  key: null,
  count: 100,
  label: 'All Deals',
  subStatuses: [],
};
